export default __webpack_public_path__ + "static/media/AssureHire.4a8c300e.svg";